import { render, staticRenderFns } from "./TopUpModal.vue?vue&type=template&id=4cbeceef"
import script from "./TopUpModal.vue?vue&type=script&lang=js"
export * from "./TopUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports